var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"lv-table-column-space"},_vm._l((_vm.columns),function(col,colIndex){return _c('td',{key:colIndex},[_c('div',{style:({width:_vm.$lv.$utils.unit(col.width)})})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }